import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

export const experimentalShare: ExperimentalMutations['experimentalShare'] = (
	_,
	{ requestBody },
	{ network: { cfetch, RateLimitedError } },
) =>
	cfetch(`/gateway/api/share`, {
		method: 'POST',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		body: JSON.stringify(requestBody),
	}).then(
		/* onFulfilled */ (response) => ({
			status: String(response.status),
			success: Boolean(response.ok),
		}),
		/* onRejected */ (error) => {
			if (error instanceof RateLimitedError) {
				// rate limiting errors from share service are not unexpected
				return {
					status: String(error.response?.status),
					success: false,
				};
			}
			throw error;
		},
	);
